import { render, staticRenderFns } from "./RecommendationCard.vue?vue&type=template&id=4453b550&scoped=true&"
import script from "./RecommendationCard.vue?vue&type=script&lang=js&"
export * from "./RecommendationCard.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationCard.vue?vue&type=style&index=0&id=4453b550&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4453b550",
  null
  
)

export default component.exports